(function () {
  'use strict';

  function initSlider(container) {
    var before = container.querySelector('.roji-hero__image--before');
    var divider = container.querySelector('.roji-hero__divider');
    var handle = container.querySelector('.roji-hero__handle');

    if (!before || !divider || !handle) return;

    var step = parseFloat(container.dataset.step) || 5;
    var dragging = false;

    function setPosition(percent) {
      percent = Math.min(100, Math.max(0, percent));
      before.style.clipPath =
        'polygon(0 0, ' + percent + '% 0, ' + percent + '% 100%, 0 100%)';
      divider.style.left = percent + '%';
      handle.setAttribute('aria-valuenow', Math.round(percent));
    }

    function percentFromClientX(clientX) {
      var rect = container.getBoundingClientRect();
      var x = clientX - rect.left;
      return (x / rect.width) * 100;
    }

    function onPointerDown(event) {
      dragging = true;
      container.setPointerCapture && container.setPointerCapture(event.pointerId);
      setPosition(percentFromClientX(event.clientX));
      handle.focus();
      event.preventDefault();
    }

    function onPointerMove(event) {
      if (!dragging) return;
      setPosition(percentFromClientX(event.clientX));
    }

    function onPointerUp(event) {
      dragging = false;
      container.releasePointerCapture &&
        event.pointerId !== undefined &&
        container.releasePointerCapture(event.pointerId);
    }

    function onKeyDown(event) {
      var current = parseFloat(handle.getAttribute('aria-valuenow')) || 0;

      if (event.key === 'ArrowLeft') {
        setPosition(current - step);
        event.preventDefault();
      } else if (event.key === 'ArrowRight') {
        setPosition(current + step);
        event.preventDefault();
      } else if (event.key === 'Home') {
        setPosition(0);
        event.preventDefault();
      } else if (event.key === 'End') {
        setPosition(100);
        event.preventDefault();
      }
    }

    container.addEventListener('pointerdown', onPointerDown);
    container.addEventListener('pointermove', onPointerMove);
    container.addEventListener('pointerup', onPointerUp);
    container.addEventListener('pointercancel', onPointerUp);
    handle.addEventListener('keydown', onKeyDown);

    // Dragging the handle itself shouldn't also trigger the container's
    // own pointerdown percent-jump before the drag starts.
    handle.addEventListener('pointerdown', function (event) {
      event.stopPropagation();
      onPointerDown(event);
    });
  }

  function init() {
    document.querySelectorAll('[data-roji-hero-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
